import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {LanguageService} from './language.service';
import {CacheService} from '../cache/cache.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'language',
  template: `{{ translate(key, defaultValue, args, languageResources | async) }}`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LanguageComponent {
  @Input() key: string;
  @Input() defaultValue: string;
  @Input() args: string[];
  languageResources: Observable<string>;

  constructor(cacheService: CacheService) {
    this.languageResources = cacheService.getLanguageResource();
  }

  translate(key: string, defaultValue: string, args: string[], languageResource: string): string {
    return LanguageService.translate(key, defaultValue, languageResource, args);
  }
}
